
export default {
    name: 'BusinessEmployees',
    props: {
        /**
         * Is the user allowed to manage this business
         */
        canManage: {
            type: Boolean,
            default: true,
        },
        /**
         * An array of employees
         */
        employees: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            allEmployees: this.employees,
            manage: false,
            showInvite: false,
        };
    },
    methods: {
        confirmRemoval(employee) {
            this.$store.dispatch('showConfirm', {
                callback: () => {
                    this.removeEmployee(employee);
                },
                confirmButtonText: this.$t('common.remove'),
                text: this.$t('business.confirm_employee_remove'),
            });
        },
        async removeEmployee(employee) {
            const { message } = await this.$axios.$put(
                `${this.$config.endpoints.organisation}/${employee.organisation.slug}/remove/${employee.slug}`,
            );
            this.$store.dispatch('setFlashMessage', { message });
            this.allEmployees = this.allEmployees.filter((checkEmployee) => checkEmployee !== employee);
        },
    },
};
